const isPlainObject = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

export function positiveNumber(value) {
  const number = Number.parseFloat(value);
  return Number.isFinite(number) && number > 0 ? number : undefined;
}

export function mergeViewerOptions(defaults, overrides = {}) {
  const safeOverrides = isPlainObject(overrides) ? overrides : {};

  return {
    ...defaults,
    ...safeOverrides,
    i18n: {
      ...defaults.i18n,
      ...(isPlainObject(safeOverrides.i18n) ? safeOverrides.i18n : {}),
    },
    splideOptions: {
      ...defaults.splideOptions,
      ...(isPlainObject(safeOverrides.splideOptions)
        ? safeOverrides.splideOptions
        : {}),
      dragMinThreshold: {
        ...defaults.splideOptions?.dragMinThreshold,
        ...(isPlainObject(safeOverrides.splideOptions?.dragMinThreshold)
          ? safeOverrides.splideOptions.dragMinThreshold
          : {}),
      },
    },
  };
}

export function optionsFromElement(element) {
  const options = {
    thumbnails: true,
    fullscreen: "fullscreen",
  };
  const maxZoom = positiveNumber(element.dataset.zoommax);
  const zoomStep = positiveNumber(element.dataset.zoomstep);

  if (maxZoom !== undefined) options.maxZoom = maxZoom;
  if (zoomStep !== undefined) options.zoom = 1 + zoomStep;

  return options;
}
